import axios from "@/services/axios";
import { getPaginationValues } from "@/utils/pagination-helper";
import { computed, reactive } from "vue";

const state = reactive({
  selectedResearchGroup: {} as any,
  group: [],
});

export default function ResearchGroupRepositoryAPI() {
  async function load(): Promise<void> {
    const data = await axios
      .get(`api/v1/ResearchGroup?PageNumber=0&PageSize=50`)
      .then((response: any) => {
        return response.data;
      });
    state.group = data;
  }

  const loadItems = (data: any): void => {
    axios
      .get(
        `api/v1/ResearchGroup?PageNumber=${data.lazyParams.page}&PageSize=${data.lazyParams.rows}&Keyword=${data.keywords}`,
        {
          showAll: true,
        } as any
      )
      .then((response: any) => {
        data.researchGroup = response.data;
        data.lazyParams = getPaginationValues(response.headers);
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const loadItem = (data: any, id: string): void => {
    axios
      .get(`api/v1/ResearchGroup/${id}/detail`)
      .then((response: any) => {
        data.researchGroup.push(response.data);
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const setResearchGroup = (selected: any) => {
    state.selectedResearchGroup = selected;
  };

  return {
    setResearchGroup,
    getSelectedResearchGroup: computed(() => state.selectedResearchGroup),
    loadResearchGroupGroup: load,
    researchGroupState: computed(() => state),
    loadItems,
    loadItem,
  };
}
